module.exports = __webpack_public_path__ + "img/Illustration.aa02820c.png";